<template>
  <div class="background-container">
    <div class="login-zhuti">
      <!-- 这里可以添加更多内容 -->
      <img src="../assets/mkdlogo.png" style="margin-left: -600px"/>
      <h4 style="margin-left: -330px; margin-top: 30px; font-size: 20px; color: #000000;">“引领创新转型，开启新媒体时代的无限可能。”</h4>
      <div>
        <div class="image-container" style="margin-top: 40px; margin-left: 50px; float: left">
          <div class="image-wrapper">
            <img src="../assets/image1.png" style="width: 220px; height:120px;" />
            <div class="overlay">
              <div class="text">
                <h3 class="overlay-text">芒可亿生态</h3>
                <div class="hover-text">芒可店直播辅助管理系统与相关产品共同搭建二手机品类生态，做到不需要客服、不需要售后、不需要找货源</div>
              </div>
            </div>
          </div>
        </div>
        <div class="image-container" style="margin-top: 40px; margin-left: 50px; float: left">
          <div class="image-wrapper">
            <img src="../assets/image1.png" style="width: 220px; height:120px;" />
            <div class="overlay">
              <div class="text">
                <h3 class="overlay-text">电商学院教学</h3>
                <div class="hover-text">芒可店直播辅助管理系统已与多个平台进行数据连接，针对不同平台芒可亿电商学院都为商家提供专业教学</div>
              </div>
            </div>
          </div>
        </div>
        <div class="image-container" style="margin-top: 40px; margin-left: 50px; float: left">
          <div class="image-wrapper">
            <img src="../assets/image1.png" style="width: 220px; height:120px;" />
            <div class="overlay">
              <div class="text">
                <h3 class="overlay-text">市场数据</h3>
                <div class="hover-text">采用最智能的方式统计市场真实成交价，自动化生成符合市场成交价格，商家可以第一时间获得市场动态与价格波动</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 style="margin-top: 220px"><span style="margin-left: 60px;">*</span><span style="color: #000000;">帮助：</span><a href="https://mangkeyi.yuque.com/tluy7x/rpi080" target="_blank">芒可店使用教程</a></h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "home"
}
</script>

<style scoped>
h1 {
  float: left;
  margin-top: 230px;
  margin-left: -760px;
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
span {
  color: #FF0909;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 32% */
}
.background-container {
  background-color: rgba(255, 235, 219, 0.27); /* 淡橙色背景 */
  width: 100%;
  height: 450px;
  display: flex; /* 使用 Flexbox 布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
}
.login-zhuti {
  width: 100%; /* 设置宽度 */
  max-width: 900px; /* 设置最大宽度（可根据需要调整） */
  height: 400px; /* 设置高度 */
  background-color: #FFFFFF; /* 白色背景 */
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  padding: 20px; /* 内边距 */
  box-sizing: border-box; /* 包括边框和内边距在内 */
}

.image-container {
  position: relative;
  width: 200px;
  height: 100px;
}

.image-wrapper {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgba(0, 0, 0, 0.0); /* 半透明背景色 */
  transition: opacity 0.3s ease;
}

.text {
  color: #000000;
}

.overlay-text {
  margin-top: -10px;
  margin-left: 15px;
  font-size: 18px;
}

.hover-text {
  display: none;
  background: rgba(0, 0, 0, 0.0);
  color: #000000;
  padding: 10px;
  font-size: 14px;
  line-height: 20px;
  margin-top: 14px;
  height: 100px;
  width: 100%;
  text-align: left;
}

.image-wrapper:hover .overlay .overlay-text {
  display: none;
}

.image-wrapper:hover .overlay .hover-text {
  display: block;
}

.image-wrapper img {
  display: block;
  width: 200px;
  height: 100px;
}


</style>



// WEBPACK FOOTER //
// src/views/home.vue